import React from "react";
import ideaLogo from "@/assets/idea-logo.png";

/**
 * BrandMark — the shared IDEA header brand used by every login card and by
 * several dashboards (AdminDashboard, SalesDashboard, Reports, Landing,
 * TechnicianLogin, AdminLogin, SalesLogin).
 *
 * The IDEA artwork is rendered from the OFFICIAL asset at
 * `/app/frontend/src/assets/idea-logo.png` — NEVER redrawn in CSS. Contextual
 * subtitles (SUPERVISOR, SALES TEAM, ST01, LIVE BUILD, REPORTS …) stay as
 * dynamic UI text with the existing electric-cyan accent + underline.
 */
export function BrandMark({ subtitle = "LIVE BUILD", small = false }) {
  return (
    <div className="flex items-center gap-3" data-testid="brand-mark">
      <img
        src={ideaLogo}
        alt="IDEA"
        draggable={false}
        className={`w-auto shrink-0 select-none ${small ? "h-6" : "h-9"}`}
        style={{ objectFit: "contain" }}
        data-testid="brand-logo"
      />
      {subtitle && (
        <div className="relative">
          <span
            className="overline"
            style={{ color: "var(--accent)", fontWeight: 600 }}
          >
            {subtitle}
          </span>
          <div
            className="absolute -bottom-1 left-0 h-[2px]"
            style={{ width: "40%", background: "var(--accent)" }}
          />
        </div>
      )}
    </div>
  );
}
